import { Box, Chip, useTheme } from "@mui/material";
import type { StatusKind } from "../../theme/mixins";

export function StatusChip({ status, label }: { status: StatusKind; label: string }) {
  const theme = useTheme();
  return (<Chip
      label={label || "-"}
      size="small"
      variant="soft"
      sx={theme.mixins.statusChip(status)}
    />
)}

export function SeverityBadge({ value }: { value?: string }) {
  const theme = useTheme();
  return (
    <Chip
      label={value || "-"}
      size="small"
      variant="soft"
      sx={theme.mixins.sevBadge(value)}
    />
  );
}

/**
 * Role pill. Built from the darkened `palette.status.*` foregrounds rather than
 * the `roleBadge` mixin: that mixin paints "Beheerder" as `brand.icon` on
 * `surface.cyan` (~2.8:1) which fails WCAG 1.4.3 (audit 2.9.1 / contrast sweep).
 */
export function RoleBadge({ role }: { role?: string }) {
  const theme = useTheme();
  const { palette } = theme;

  const map: Record<string, [string, string]> = {
    "Super Admin": [palette.brand.navy, palette.common.white],
    Beheerder: [palette.status.runningBg, palette.status.runningFg],
    Manager: [palette.background.neutral, palette.brand.navy],
    Gebruiker: [palette.status.neutralBg, palette.status.neutralFg],
  };
  const [bg, fg] = map[role || ""] || [
    palette.status.neutralBg,
    palette.status.neutralFg,
  ];

  return (
    <Chip
      label={role}
      size="small"
      sx={{
        fontSize: 12,
        fontWeight: 700,
        background: bg,
        color: fg,
      }}
    />
  );
}
